import data from "@/data/trolls.json";
import trail from "@/data/trail.json";

export const TROLLS = data.trolls;
export const TRAIL = trail;

export const RARITY_COLORS = {
  common: "#8A8473",
  rare: "#6D7C5E",
  epic: "#B37A4B",
  legendary: "#D19E59",
};

export const XP_TABLE = [
  ["common", 50],
  ["rare", 120],
  ["epic", 300],
  ["legendary", 800],
];

export const isFestival = (t) => t.category.startsWith("festival");

// The 12 trolls with finished paintings; the rest show a "hidden troll" painting.
export const PAINTED = [
  "fossekongen", "nordlysdronninga", "bekkefrua", "elvejotnen", "kaptein-morgan", "myrmor",
  "vetle-veiviser", "solbarnet", "stormbarnet", "sol-sigrid", "jonsokdanseren", "kremmer-kari",
];
const HIDDEN = ["hidden-birch", "hidden-waterfall", "hidden-mound", "hidden-boulder"];
export const isPainted = (t) => PAINTED.includes(t.slug);
export const artFor = (t) => {
  const key = isPainted(t) ? t.slug : HIDDEN[Number(t.id.slice(1)) % HIDDEN.length];
  return { lg: `/trolls/${key}.webp`, sm: `/trolls/${key}-sm.webp`, painted: isPainted(t) };
};
export const bySlug = (slug) => TROLLS.find((t) => t.slug === slug);

export const FILTERS = {
  all: () => true,
  common: (t) => t.rarity === "common",
  rare: (t) => t.rarity === "rare",
  epic: (t) => t.rarity === "epic",
  legendary: (t) => t.rarity === "legendary",
  festivals: isFestival,
  merchants: (t) => t.category === "merchant",
  weekend: (t) => t.category === "weekend",
  promo: (t) => t.category === "promo",
};

const md = (year, mmdd) => {
  const [m, d] = mmdd.split("-").map(Number);
  return new Date(year, m - 1, d);
};

// Current or next occurrence of a recurring MM-DD window (handles year wrap).
export function nextWindow(start, end, today = new Date()) {
  const now = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  for (const y of [now.getFullYear() - 1, now.getFullYear(), now.getFullYear() + 1]) {
    const s = md(y, start);
    const e = md(end < start ? y + 1 : y, end);
    if (e >= now) return { start: s, end: e, live: s <= now };
  }
  return null;
}


